function kieneDevPublicBase(): string {
    if (typeof document !== 'undefined' && document.baseURI) {
        return document.baseURI.endsWith('/') ? document.baseURI : `${document.baseURI}/`;
    }
    return 'https://dev.vetvet.de/';
}

export const environment = {
    SUB_TITLE: 'DEV',
    production: false,
    beta: false,
    dev: true,
    get SIGNATURE_URL(): string {
        return kieneDevPublicBase();
    },
    get BASE_URI(): string {
        return new URL('api/', kieneDevPublicBase()).href;
    },
    posthogKey: '',
    posthogHost: '',
    posthogEnv: 'dev',
    HIT_QS_BACKEND: 'http://vr10152.webspaceconfig.de:8081/kienehitqsapi/resources/debug/checknewvalues',
    VERSION: require('./versions.ts').version,
    COMMIT: require('./versions.ts').revision,
    BRANCH: require('./versions.ts').branch,
    STRIPE_PUBLIC_KEY:
        'pk_test_51RpqJCEDH054uQwKenYfTm8LewCOT2Vxu4hy6WOhcRJb6k8cW1IH8hRc3cSDtvLDHWICWuS4MLJx2ximzoOpvrEA00P4Tw9k1n',
};
